import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

// Custom validator function
export function passwordMatchValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const password = formGroup.get('password')?.value;
        const verifyPassword = formGroup.get('verifypassword')?.value;

        if (password && verifyPassword && password !== verifyPassword) {
            return {passwordMismatch: true}; // Error key
        }
        return null; // Valid
    };
}
